
// pass a function to cache the response - the function will never be called again even if the parameters have changed
export const cache0 = (fn) => {
    let cache = null;
    let invoked = false;

    return (...args) => {
        if (!invoked) {
            cache = fn(...args);
            invoked = true;
        }
        return cache;
    };
};

